import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ThemingService} from '../../theming.service';

@Injectable({providedIn: 'root'})
export class UnloadClientThemeGuard  {
  constructor(
    private themingService: ThemingService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.themingService.loadDefaultTheme();
    return true;
  }
}
